export default __webpack_public_path__ + "static/media/Y.df861b4f.svg";